import React from "react";
import DataTable from "@/components/Datatable/Datatable";
import MainPageWrapper from "@/components/MainPageWrapper/MainPageWrapper";
import { useTransactionHistoryReport } from "../../hooks/useTransactionHistoryReport";
import { useDownloadTransactionHistoryReportCsv } from "../../hooks/useDownloadTransactionHistoryReportCsv";
import { transactionHistoryReportColumns } from "../TransactionHistoryReportColumns/TransactionHistoryReportColumns";
import TransactionHistoryReportFilters from "../TransactionHistoryReportFilters/TransactionHistoryReportFilters";
import { TransactionHistoryReportItem } from "../../api/fetchTransactionHistoryReport/types";

const columns = transactionHistoryReportColumns();

const TransactionHistoryReportPage: React.FC = () => {
  const {
    items,
    totalCount,
    totals,
    loading,
    error,
    pagination,
    sorting,
    filters,
    exportParams,
    handlePaginationChange,
    handleSortingChange,
    handleFilterChange,
  } = useTransactionHistoryReport();

  const { loading: csvLoading, downloadCsv } =
    useDownloadTransactionHistoryReportCsv();

  return (
    <MainPageWrapper title="Transaction History Report">
      <TransactionHistoryReportFilters
        filters={filters}
        isExporting={csvLoading}
        onExportCsv={() => downloadCsv(exportParams)}
        onFilterChange={handleFilterChange}
      />

      {totals && (
        <div className="mb-4 flex flex-wrap gap-6 rounded-md border border-gray-200 bg-white px-4 py-3 text-sm dark:border-slate-700 dark:bg-slate-800">
          <div>
            <span className="text-gray-500 dark:text-gray-400">Gross</span>{" "}
            <span className="font-medium text-gray-900 dark:text-white">
              ${totals.gross}
            </span>
          </div>
          <div>
            <span className="text-gray-500 dark:text-gray-400">Discount</span>{" "}
            <span className="font-medium text-gray-900 dark:text-white">
              ${totals.discount}
            </span>
          </div>
          <div>
            <span className="text-gray-500 dark:text-gray-400">Net</span>{" "}
            <span className="font-medium text-gray-900 dark:text-white">
              ${totals.net}
            </span>
          </div>
        </div>
      )}

      <DataTable<TransactionHistoryReportItem>
        columns={columns}
        data={items}
        error={error}
        loading={loading}
        noDataMessage="No transactions found"
        onPageChange={(newPageIndex, newPageSize) =>
          handlePaginationChange({
            pageIndex: newPageIndex,
            pageSize: newPageSize,
          })
        }
        onSortingChange={handleSortingChange}
        pageIndex={pagination.pageIndex}
        pageSize={pagination.pageSize}
        rowKeyExtractor={(_row, index) => `${pagination.pageIndex}-${index}`}
        sorting={sorting}
        totalCount={totalCount}
      />
    </MainPageWrapper>
  );
};

export default TransactionHistoryReportPage;
